import { Injectable } from '@angular/core';
import { LikertDataService } from './likert-data.service';
import { Likert } from './model/likert.model';

@Injectable({
  providedIn: 'root',
})
export class LikertMockService implements LikertDataService {

  readonly responseLikertSuccess = {
    data: {
      request_id: "664c14fc-d4e6-5af9-b81e-49f958822dd6"
    },
    links: [],
    errors: []
  };

  readonly responseLikertError = {
    error: {
      codigo: "400",
      mensagem: "Erro na validação dos parâmetros de entrada.",
      campos: [
        {
          mensagem: "must be less than or equal to 4",
          campo: "nota"
        }
      ]
    }
  };

  postLikert(likertForm: Likert): Promise<any> {
    return Promise.resolve(this.responseLikertSuccess);
  }

}
